<template>
  <div>
    <div>
      <el-input></el-input>
      <el-button>绑定</el-button>
    </div>
    <el-upload
      action="/api/uploadTechnicianAvatar?technicianId=14"
      :show-file-list="false">
      <el-button>vvv</el-button>
    </el-upload>

    <div style="padding: 20px; width: 100px; text-align: center">
      <el-button @click="next">next</el-button>
      <transition name="fade" mode="out-in">
        <div :key="curIndex">{{listData[curIndex].name}}</div>
      </transition>
    </div>
    <div id="abc" style="width: 100px">ABC</div>

    <div style="padding: 20px;">
      <el-button @click="next2">next</el-button>
      <el-table
        border=""
        :data="tableDataList[curIndex2]"
        style="width: 100%">
        <el-table-column
          prop="date"
          label="日期"
          width="180"
          align="center">
          <template #default="{row}">
            <transition name="fade" mode="out-in">
              <div :key="curIndex2">{{row.date}}</div>
            </transition>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="180"
          align="center">
          <template #default="{row}">
            <transition name="fade" mode="out-in">
              <div :key="curIndex2">{{row.name}}</div>
            </transition>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          align="center">
          <template #default="{row}">
            <transition name="fade" mode="out-in">
              <div :key="curIndex2">{{row.address}}</div>
            </transition>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="padding: 20px">
      <button v-on:click="shuffle">Shuffle</button>
      <transition-group name="flip-list" tag="ul">
        <li v-for="item in items" v-bind:key="item">
          {{ item }}
        </li>
      </transition-group>
    </div>

    <div class="redLight"></div>
  </div>
</template>

<script>
  // https://www.cnblogs.com/wangshuo1/p/5446097.html

  export default {
    name: 'Test',
    data () {
      return {
        check: false,
        over: false,
        show: true,
        curIndex: 0,
        curIndex2: 0,
        listData: [
          {
            show: true,
            name: '一二三'
          },
          {
            show: false,
            name: '四五六一二三'
          },
          {
            show: false,
            name: '七八九'
          }
        ],
        tableDataList: [
          [
            {
              date: '2016-05-02',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1518 弄'
            }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1517 弄'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }
          ],
          [
            {
              date: '2016-05-02',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1517 弄'
            }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }
          ]
        ],
        items: [1, 2, 3, 4, 5, 6, 7, 8, 9]
      }
    },
    created () {
    },
    mounted () {
      const timer = setInterval(() => this.next2(), 10000)
      this.$once('hook:beforeDestroy', () => clearInterval(timer))
    },
    methods: {
      next () {
        this.curIndex = (this.curIndex + 1) % 3
      },
      next2 () {
        this.curIndex2 = (this.curIndex2 + 1) % 2
      },
      shuffle: function () {
        this.items = this.$_.shuffle(this.items)
      }
    },
    computed: {}
  }
</script>

<style lang="scss" scoped>
  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: rotateY(90deg);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.6s;
  }

  .flip-list-move {
    transition: transform 1s;
  }
  @keyframes scale {
    0% {
      transform: scale(1)
    }
    50%, 75% {
      transform: scale(2)
    }
    78%, 100% {
      opacity: 0
    }
  }

  .redLight {
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin: 100px 100px 50px 200px;
  }

  .redLight:before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    opacity: .7;
    background-color: red;
    animation: scale 2s infinite cubic-bezier(0, 0, .49, 1.02);
    animation-delay: 200ms;
  }
</style>
